import {useQuery} from "@tanstack/react-query";
import {MIN} from "../../util/time-and-date.js";
import {get} from "../../api/_fetch.js";
import {API_ROUTE_CRYPTO_BALANCE} from "../../../../back-end/constants/API-ROUTES.js";
import orderBy from "lodash/orderBy.js";
import {useState} from "react";

export const getCryptoBalances = () => get(API_ROUTE_CRYPTO_BALANCE)

export const useCryptoBalances = () => {

    const [isSortedByValue, setIsSortedByValue] = useState(false)
    const accountSortProp = isSortedByValue ? 'totalValue' : 'lastActivity'

    const {data = [], isLoading} = useQuery({
        queryKey: ['crypto-balances'],
        queryFn: getCryptoBalances,
        refetchInterval: 5 * MIN,
    })

    const balancesGroupedByAddress = data.reduce((acc, cur) => {
        if(!acc[cur.address]){
            acc[cur.address] = { assets: [], totalValue:0, }
        }
        return {
            ...acc,
            [cur.address]: {
                comment: cur.comment,
                location: cur.location,
                address: cur.address,
                lastActivity: cur.last_activity || '2020-01-01',
                isActive: cur.is_active === 1,
                totalValue: acc[cur.address].totalValue + cur.value,
                assets: [
                    ...acc[cur.address].assets,
                    {
                        code: cur.code,
                        name: cur.name,
                        assetId: cur.asset_id,
                        tokenAddress: cur.token_address,
                        value: cur.value,
                        balance: cur.balance,
                    }
                ]
            }
        }
    }, {})

    const balancesGroupedByAsset = data.reduce((acc, cur) => {
        if(!acc[cur.code]){
            acc[cur.code] = { quantity: 0, totalValue:0, addresses: 0, }
        }
        return {
            ...acc,
            [cur.code]: {
                totalValue: acc[cur.code].totalValue + cur.value,
                quantity: acc[cur.code].quantity + cur.balance,
                addresses: acc[cur.code].addresses + 1,
                name: cur.name,
                code: cur.code,
            }
        }
    }, {})

    return {
        isLoading,
        data,
        accounts: orderBy(Object.values(balancesGroupedByAddress),[accountSortProp],['desc']),
        assets: orderBy(Object.values(balancesGroupedByAsset),['totalValue'],['desc']),
        isSortedByValue,
        toggleSort: () => setIsSortedByValue(!isSortedByValue)
    }
}